<div id="cspTenant_View" *ngIf="showUI">
  <div class="order-reference">
    <table style="width: 100%;">
      <tr>
        <td *ngIf="proType == 'CSP' && getTenantView?.showDefaultOwnerEmail == '1'">
          <div class="usage-default-owner-email" *ngIf="getTenantView?.showDefaultOwnerEmail == '1'">
            DEFAULT OWNER EMAIL&nbsp;&nbsp;
            <input id="defaultOwnerEmail" required maxlength="50" value="{{getTenantView?.defaultOwnerUsageEmail}}"
              type="email" />
          </div>
        </td>
        <!-- <td *ngIf="proType == 'CSP'">
          <div class="csp-mpn float-left"> -->
            <!-- MPN ID&nbsp;&nbsp;
            <mat-form-field>
              <input type="number" name="matmpnid" aria-label="Number"
                [(ngModel)]="mpnIdSelect" #trigger="matAutocompleteTrigger" (ngModelChange)="selectMpnId()" matInput [formControl]="myControl"
                [matAutocomplete]="auto">
              <i class="material-icons align-arrow-right" (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let mpn of mpnList" [value]="mpn">
                  {{mpn}}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matSuffix *ngIf="proType == 'CSP'" class="usernameicon" placement="bottom"
                ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
                info</mat-icon>
              <mat-icon matSuffix *ngIf="proType != 'CSP'" class="usernameicon" placement="bottom"
                ngbTooltip="Reseller Customer Number for Autodesk">
                info</mat-icon>
            </mat-form-field> -->
            <!-- <ng-select class="customDropdwon" [items]="mpnList" [(ngModel)]="mpnIdSelect" bindValue="mpn"
              bindLabel="mpn" placeholder="MPN ID" (change)="selectMpnId()"></ng-select>
            <mat-icon *ngIf="proType == 'CSP'" class="usernameicon" placement="bottom"
              ngbTooltip="Microsoft Partner Network ID, if you need to obtain or confirm your MPN ID please go to https://partner.microsoft.com/en-AU/ or call the Microsoft Partner Hotline on 13 20 58 (Options 2,5,1)">
              info</mat-icon>
            <mat-icon *ngIf="proType != 'CSP'" class="usernameicon" placement="bottom"
              ngbTooltip="Reseller Customer Number for Autodesk">
              info</mat-icon> -->
          <!-- </div>
        </td> -->
      </tr>
    </table>
  </div>
  <div id="csptabs" class="tenant-tab-background">
    <ul id="pills-tab" class="nav nav-pills mb-3 subTitleBar" role="tablist">
      <li class='nav-item'>
        <a id="li_select_tenant" aria-controls="pills-select" data-toggle="pill" href="#csptabs-1-{{proType}}"
          aria-selected="true" class="nav-link active" role="tab" (click)="checkRadioButton('select')">
          <input type="radio" value="select" [(ngModel)]="comparedValue">
          Select End User
        </a>
      </li>
      <li class='nav-item'>
        <a id="li_create_tenant" aria-controls="pills-create" data-toggle="pill" href="#csptabs-2-{{proType}}"
          aria-selected="false" class="nav-link" role="tab" (click)="checkRadioButton('create')">
          <input type="radio" value="create" [(ngModel)]="comparedValue">
          Create New End User
        </a>
      </li>
      <li class='nav-item'>
        <a *ngIf="proType == 'CSP'" aria-controls="pills-associate" id="li_associate_tenant" data-toggle="pill"
          href="#csptabs-3-{{proType}}" aria-selected="false" class="nav-link" role="tab"
          (click)="checkRadioButton('associate')">
          <input type="radio" value="associate" [(ngModel)]="comparedValue">
          Associate
        </a>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="csptabs-1-{{proType}}" role="tabpanel"
        aria-labelledby="pills-select-tab">
        <div class="noResult-wrapper OrignalResult"
          *ngIf="!getCSPTenantList?.length && !getADMTenantList?.length && !getADYTenantList?.length">
          <div class="top-divider"></div>
          <div><img src="../images/new_ui/attention.png"></div>
          <div id="reason">NO TENANT AVAILABLE</div>
        </div>

        <div class="tenant_header"
          *ngIf="getCSPTenantList?.length || getADMTenantList?.length || getADYTenantList?.length">

          <div class="filter-wrapper">
            <div class="searchInputGroup">
              <div class="searchIcon">
                <img src="../images/new_ui/filter.png">
              </div>
              <input class="searchInput tenant_search_input" type="text" placeholder="Search tenant by any information"
                [(ngModel)]="searchTenantText" (keyup)="searchTenant(proType)">
            </div>
          </div>

          <div class="top-divider"></div>


        </div>

        <div class="my-tenant-body shared-outer-wrapper" *ngIf="getADYTenantList?.length">
          <table id='tenantListTable_{{proType}}' class="table table-hover " style="padding:10px 0">
            <tr>
              <th class="col">
                <label for="COMPANY_NAME">COMPANY NAME</label>
              </th>
              <th class="col">
                <label for="ADDRESS">ADDRESS</label>
              </th>
              <th class="col">
                <label for="EMAIL">EMAIL</label>
              </th>
              <th class="col">
                <label for="PREFIX">PREFIX</label>
              </th>
              <th class="col"></th>
            </tr>

            <!-- <tr
              *ngFor="let getADYTenant of filterADYTenantList | paginate: { itemsPerPage: 15, currentPage: pady, id: 'pady' }"> -->
            <tr *ngFor="let getADYTenant of filterADYTenantList"
              [class.selectedTenantClass]="(getADYTenant?.out_tenant_id == selectedTenantId)">

              <td id="ADYcompanyName" class="align-left expand w200">
                {{getADYTenant?.out_company_name}}
              </td>
              <td class="align-left expand w200">
                <div id="ADYaddress">
                  <span *ngIf="getADYTenant?.out_address_1">{{getADYTenant?.out_address_1}}<br /></span>
                  <span *ngIf="getADYTenant?.out_address_2">{{getADYTenant?.out_address_2}}<br /></span>
                  <span *ngIf="getADYTenant?.out_address_3">{{getADYTenant?.out_address_3}}<br /></span>
                  <span *ngIf="getADYTenant?.out_city || getADYTenant?.out_region || getADYTenant?.out_post_code">
                    {{getADYTenant?.out_city}} {{getADYTenant?.out_region}}{{getADYTenant?.out_post_code}}<br />
                  </span>
                  <span *ngIf="getADYTenant?.out_phone">Phone: {{getADYTenant?.out_phone}}</span>
                </div>
              </td>
              <td id="ADYemail" class='expand w200'>
                {{getADYTenant?.out_email}}
              </td>
              <td class='expand w100'>
                {{getADYTenant?.out_prefix}}
              </td>
              <td class="selectbutton">
                <button [hidden]="getADYTenant?.out_tenant_id == selectedTenantId" [id]="getADYTenant?.out_tenant_id" class="button button-red button-mid"
                  (click)="selectNoneCSPTenant(getADYTenant?.out_tenant_id, proType, getADYTenant)">
                  Select
              </button>
                <button [hidden]="getADYTenant?.out_tenant_id !== selectedTenantId" class="button button-red button-mid">Selected</button>
              </td>
            </tr>
          </table>
          <!-- <pagination-controls id="pady" (pageChange)="pady = $event" directionLinks="true" previousLabel=""
            nextLabel="" class="search-pagination"></pagination-controls> -->
        </div>

        <mat-spinner
          *ngIf="!getCSPTenantList?.length"
          style="display: inline-block;"
          mode="indeterminate"
          class="circle cSPCustomerEntitlements-loading"
          diameter="20"
        >
        </mat-spinner>
        <div class="my-tenant-body" *ngIf="getCSPTenantList?.length">
          <table id='tenantListTable_{{proType}}' class="table table-hover" style="padding:10px 0">
            <tr>
              <th scope="col" style="width: 15%">
                <label for="COMPANY_NAME">COMPANY NAME</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="ADDRESS">ADDRESS</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="EMAIL">EMAIL</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="PREFIX">PREFIX</label>
              </th>
              <th scope="col" style="width: 10%"></th>
            </tr>

            <!-- <tr *ngFor="let getTenant of filterCSPTenantList | paginate: { itemsPerPage: 15, currentPage: pcsp, id: 'pcsp' }"> -->
            <ng-container *ngFor="let getTenant of filterCSPTenantList">
              <tr [class.selectedTenantClass]="getTenant?.out_tenant_id === selectedTenantId">
                <td id="companyName" class="align-left expand w200">
                  {{getTenant?.out_company_name}}
                </td>
                <td class="align-left expand w200">
                  <div id="address">
                    <span *ngIf="getTenant?.out_address_1">{{getTenant?.out_address_1}}<br /></span>
                    <span *ngIf="getTenant?.out_address_2">{{getTenant?.out_address_2}}<br /></span>
                    <span *ngIf="getTenant?.out_address_3">{{getTenant?.out_address_3}}<br /></span>
                    <span *ngIf="getTenant?.out_city || getTenant?.out_region || getTenant?.out_post_code">
                      {{getTenant?.out_city}} {{getTenant?.out_region}}{{getTenant?.out_post_code}}<br />
                    </span>
                    <span *ngIf="getTenant?.out_phone">Phone: {{getTenant?.out_phone}}</span>
                  </div>
                </td>
                <td id="email" class='expand w200'>
                  {{getTenant?.out_email}}
                </td>
                <td class='expand w100'>
                  {{getTenant?.out_prefix}}
                </td>
                <td class="selectbutton">
                  <div [hidden]="getTenant?.out_tenant_id == selectedTenantId" [id]="getTenant?.out_tenant_id"
                    class="selectBtn button button-red button-tiny button-hover-white"
                    (click)="selectCSPTenant(getTenant?.out_tenant_id, getTenant)">
                    Select
                  </div>
                  <div [hidden]="getTenant?.out_tenant_id !== selectedTenantId"
                    class="selectBtn button button-red button-tiny button-hover-white">Selected</div>
                </td>
              </tr>
            </ng-container>

          </table>
          <!-- <pagination-controls id="pcsp" (pageChange)="pcsp = $event" directionLinks="true" previousLabel=""
            nextLabel="" class="search-pagination"></pagination-controls> -->
        </div>


        <div class="my-tenant-body" *ngIf="getADMTenantList?.length">
          <table id='tenantListTable_{{proType}}' class="table table-hover " style="padding:10px 0">
            <tr>
              <th scope="col" style="width: 15%">
                <label for="COMPANY_NAME">COMPANY NAME</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="ADDRESS">ADDRESS</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="EMAIL">EMAIL</label>
              </th>
              <th scope="col" style="width: 25%">
                <label for="PREFIX">PREFIX</label>
              </th>
              <th scope="col" style="width: 10%"></th>
            </tr>

            <!-- <tr *ngFor="let getADMTenant of filterADMTenantList | paginate: { itemsPerPage: 15, currentPage: padm, id: 'padm' }"> -->
            <tr *ngFor="let getADMTenant of filterADMTenantList"
              [ngClass]="(getADMTenant?.out_tenant_id == selectedTenantId) ? 'selectedTenantClass' : ''">
              <td id="ADMcompanyName" class="align-left expand w200">
                {{getADMTenant?.out_company_name}}
              </td>
              <td class="align-left expand w200">
                <div id="ADMaddress">
                  <span *ngIf="getADMTenant?.out_address_1">{{getADMTenant?.out_address_1}}<br /></span>
                  <span *ngIf="getADMTenant?.out_address_2">{{getADMTenant?.out_address_2}}<br /></span>
                  <span *ngIf="getADMTenant?.out_address_3">{{getADMTenant?.out_address_3}}<br /></span>
                  <span *ngIf="getADMTenant?.out_city || getADMTenant?.out_region || getADMTenant?.out_post_code">
                    {{getADMTenant?.out_city}} {{getADMTenant?.out_region}}{{getADMTenant?.out_post_code}}<br />
                  </span>
                  <span *ngIf="getADMTenant?.out_phone">Phone: {{getADMTenant?.out_phone}}</span>
                </div>
              </td>
              <td id="ADMemail" class='expand w200'>
                {{getADMTenant?.out_email}}
              </td>
              <td class='expand w100'>
                {{getADMTenant?.out_prefix}}
              </td>
              <td class="selectbutton">
                <button [hidden]="getADMTenant?.out_tenant_id == selectedTenantId" [id]="getADMTenant?.out_tenant_id" class="button button-red button-mid"
                  (click)="selectNoneCSPTenant(getADMTenant?.out_tenant_id, proType, getADMTenant)">
                  Select
              </button>
                <button [hidden]="getADMTenant?.out_tenant_id !== selectedTenantId" class="button button-red button-mid">Selected</button>
              </td>
            </tr>
          </table>
          <!-- <pagination-controls id="padm" (pageChange)="padm = $event" directionLinks="true" previousLabel=""
            nextLabel="" class="search-pagination"></pagination-controls> -->
        </div>
      </div>

      <div *ngIf="proType == 'CSP'" id="csptabs-2-{{proType}}" class="tab-pane fade" role="tabpanel"
        aria-labelledby="pills-create-tab">
        <div [formGroup]="userFormGroup">
          <div class="userinfo" formGroupName="userGroup">
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="domainPrefixValidate" formControlName="prefixField" (blur)="checkPrefix()"
                placeholder="DOMAIN PREFIX" required>
              <span matSuffix>.onmicrosoft.com</span>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="userNameValidate" formControlName="userNameField" placeholder="USER NAME" requried>
              <mat-icon class="usernameicon" placement="bottom" ngbTooltip="Default login is admin">info
              </mat-icon>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="FIRST NAME"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="LAST NAME" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="COMPANY NAME"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="emailValidate" formControlName="emailField" placeholder="EMAIL" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input id= "addressLine1" matInput class="addressLine1Validate" formControlName="addressLine1Field"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 1" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input id= "addressLine2" matInput class="addressLine2Validate" formControlName="addressLine2Field"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 2">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input id= "addressLine3" matInput class="addressLine3Validate" formControlName="addressLine3Field"
              (change)="omit_nonprintable_char($event)" placeholder="ADDRESS LINE 3">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="suburbValidate" [matAutocomplete]="autoSuburb"
                #myAutocompleteTriggerSub="matAutocompleteTrigger" (input)="onInputSub($event)"
                formControlName="suburbField" placeholder="SUBURB" (keyup)="startFilterSub()"
                (keydown.Tab)="chooseAutoCompletSuburb($event)" required>
              <mat-autocomplete #autoSuburb="matAutocomplete">
                <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option?.suburb"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <ng-select class="customDropdwon stateValidate" [items]="stateList" bindValue="state" bindLabel="state"
              placeholder="State *" formControlName="stateField"></ng-select> -->
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="postcodeValidate" maxlength="4"
                #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
                (keypress)="isNumberKey($event)" formControlName="postcodeField" (keyup)="startFilterPostcode()"
                (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                placeholder="POST CODE" required>
              <mat-autocomplete #autoPostcode="matAutocomplete">
                <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option?.postcode"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                placeholder="PHONE" required>
            </mat-form-field>
          </div>
        </div>
        <div class="align-center">
          <button class="button button-red button-small saveuser" (click)="createEndUser()">Create new end user</button>
        </div>
        
      </div>

      <div *ngIf="proType == 'ADM' || proType == 'ADY'" id="csptabs-2-{{proType}}" class="tab-pane fade" role="tabpanel"
        aria-labelledby="pills-create-tab">
        <!-- <form id="createADTenant_form" class="address-form profile-sub-panel">
          <div class="form-field">
            <input id="connectionId" name="connectionId" type="hidden">
          </div>
          <div class="form-field">
            <label>COMPANY NAME*</label>
            <input type="text" id="ADKcompanyNameField" name="companyNameField" class="input no-border"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label>COMPANY DESCRIPTION*</label>
            <input type="text" id="ADKcompanyDescField" name="companyDescField" required class="input no-border"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label>FIRST NAME*</label>
            <input type="text" id="ADKfirstNameField" name="firstNameField" class="input no-border" maxlength="30" />
          </div>
          <div class="form-field">
            <label>LAST NAME*</label>
            <input type="text" id="ADKlastNameField" name="lastNameField" class="input no-border" maxlength="30" />
          </div>

          <div class="form-field">
            <label>EMAIL*</label>
            <input type="text" id="ADKemailField" name="emailField" class="input no-border" maxlength="50" />
          </div>
          <div class="form-field">
            <label>ADDRESS LINE 1*</label>
            <input type="text" id="ADKaddressLine1Field" name="addressLine1Field" class="input no-border"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label>ADDRESS LINE 2</label>
            <input type="text" id="ADKaddressLine2Field" name="addressline2field" class="input no-border"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label>ADDRESS LINE 3</label>
            <input type="text" id="ADKaddressLine3Field" name="addressLine3Field" class="input no-border"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label>SUBURB*</label>
            <input type="text" id="ADKsuburbField" name="suburbField" class="input no-border suburbField"
              maxlength="30" />
          </div>
          <div class="form-field">
            <label for="STATE">STATE</label>
            <select class="form-control custom-dropdown stateMaintainValidate" id="ADKstateField" name="stateField">
              <option value="">CHOOSE A STATE</option>
              <option *ngFor="let state of stateList" value="{{state}}">{{state}}</option>
            </select>
          </div>
          <div class="form-field">
            <label for="STATE">POST CODE*</label>
            <input type="text" id="ADKpostCodeField" name="postCodeField" class="input no-border postCodeField"
              maxlength="4" />
          </div>
          <div class="form-field">
            <input id="ADKprogramType" name="programType" type="hidden" [value]="proType">
          </div>
          <div class="form-field">
            <label for="STATE">PHONE*</label>
            <input type="text" id="ADKphoneField" name="phoneField" class="input no-border" maxlength="15" />
            <input style="visibility:hidden" id="addressTypeField" />
          </div>
          <div class="form-field">
            <label for="RESELLER_CSN_">RESELLER CSN*</label>
            <select class="form-control custom-dropdown " id="resellerMPNId_Input" name="resellerMPNId_Input">
              <option *ngFor="let mpn of resellerMpnList" value="{{mpn}}">{{mpn}}</option>
            </select>
            <input name="resellerMPNId_Input" type="hidden" [value]="resellerId">
            <mat-form-field style="width: 40%;">
              <input type="number" id="resellerMPNId_Input" name="resellerMPNId"
                aria-label="Number" [(ngModel)]="resellerId" matInput #triggerResellerId="matAutocompleteTrigger"
                [matAutocomplete]="auto">
              <i class="material-icons align-arrow-right"
                (click)="showAutoCompletePanel(triggerResellerId);$event.stopPropagation()">arrow_drop_down</i>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let mpn of resellerMpnList" [value]="mpn">
                  {{mpn}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </form> -->
        <div [formGroup]="userFormGroup">
          <div class="userinfo" formGroupName="adTenantGroup">
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="companyNameValidate" formControlName="companyNameField" placeholder="COMPANY NAME"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="companyDescriptionValidate" formControlName="companyDescField" placeholder="COMPANY DESCRIPTION"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="firstNameValidate" formControlName="firstNameField" placeholder="FIRST NAME"
                required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="lastNameValidate" formControlName="lastNameField" placeholder="LAST NAME" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="emailValidate" formControlName="emailField" placeholder="EMAIL" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="addressLine1Validate" formControlName="addressLine1Field"
                placeholder="ADDRESS LINE 1" required>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="addressLine2Validate" formControlName="addressLine2Field"
                placeholder="ADDRESS LINE 2">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="addressLine3Validate" formControlName="addressLine3Field"
                placeholder="ADDRESS LINE 3">
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="suburbValidate" [matAutocomplete]="autoSuburb"
                #myAutocompleteTriggerSub="matAutocompleteTrigger" (input)="onInputSub($event)"
                formControlName="suburbField" placeholder="SUBURB" (keyup)="startFilterSub()"
                (keydown.Tab)="chooseAutoCompletSuburb($event)" required>
              <mat-autocomplete #autoSuburb="matAutocomplete">
                <mat-option *ngFor="let option of filteredSubFromAPI" [value]="option?.suburb"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <mat-select class="stateValidate" placeholder="State" formControlName="stateField" required>
                <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput class="postcodeValidate" maxlength="4"
                #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
                (keypress)="isNumberKey($event)" formControlName="postcodeField" (keyup)="startFilterPostcode()"
                (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode"
                placeholder="POST CODE" required>
              <mat-autocomplete #autoPostcode="matAutocomplete">
                <mat-option *ngFor="let option of filteredPostCodeFromAPI" [value]="option?.postcode"
                  (click)="chooseAutoComplete(option)">
                  {{option?.suburb+", "+option?.state+", "+option?.postcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field [floatLabel]="'always'">
              <input matInput (keypress)="isNumberKey($event)" class="phoneValidate" formControlName="phoneField"
                placeholder="PHONE" required>
            </mat-form-field>
            <br/>
          </div>
        </div>
        <div class="create-end-user" id="btnCreateADEndUser">
          <div class="button button-red button-large" style="padding-top: 2px; margin-top: 30px;" (click)="createADEndUser()">
            Create new end user
          </div>
        </div>
      </div>

      <div *ngIf="proType == 'CSP'" id="csptabs-3-{{proType}}" class="tab-pane fade" role="tabpanel"
        aria-labelledby="pills-create-tab">
        <div id="divAssociate" class="address-form profile-sub-panel">
          <div [formGroup]="userFormAssociateGroup">
            <div class="userinfo">
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="domainValidate" formControlName="domain" placeholder="DOMAIN"
                  (blur)="getTenantIdByDomain()" requried>
                <mat-icon class="usernameicon" placement="left"
                  ngbTooltip="Tenant Domain from Microsoft, ex. mydomain.onmicrosoft.com">info</mat-icon>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="companyIdValidate" formControlName="companyId" placeholder="COMPANY ID" required>
                <mat-icon class="usernameicon" placement="left"
                  ngbTooltip="Microsoft Customer GUID, automatically populated once the above domain verified">info
                </mat-icon>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="associateCompanyNameValidate" placeholder="COMPANY NAME"
                  formControlName="associateCompanyName">
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'">
                <input matInput class="associateEmailValidate" placeholder="EMAIL" formControlName="associateEmail"
                  required>
                <mat-icon class="usernameicon" placement="left"
                  ngbTooltip="Link to Microsoft for association will be sent to this email address">info</mat-icon>
              </mat-form-field>
              <mat-checkbox formControlName="associateCancelCC">CANCEL MY CREDIT CARD ASSOCIATED WITH MICROSOFT
              </mat-checkbox>
            </div>
          </div>
          <button class="button button-red button-small associateuser" (click)="associateEndUser()">Associate</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="tenantmodal" class="reveal small reveal-modal" data-reveal data-close-on-click="false"
  data-close-on-esc="false">
  <div class="close-reveal-modal" data-close aria-label="Close reveal" (click)="closeTenantPopup()">
    <span aria-hidden="true">&times;</span>
  </div>
  <div id="tenant_details" class="reveal-content">
    <h3>
      TENANT CREATION SUCCESSFUL
    </h3>
    <div id="tenant_details">
      <div style="padding-bottom: 20px;">
        A new Microsoft Online, Tenant has been created via the Dicker Data system. Below are the tenant details for
        your records.
      </div>
      <div>
        <table class="dark" cellpadding="0" cellspacing="0"
          style="width: 100%; border-spacing: 0px; border-collapse: collapse;">
          <tr>
            <td>
              Tenant ID
            </td>
            <td>
              <label id="TenantID"></label>
            </td>
          </tr>
          <tr>
            <td>
              Company Name
            </td>
            <td>
              <label id="CompanyName"></label>
            </td>
          </tr>
          <tr>
            <td>
              Tenant Domain
            </td>
            <td>
              <label id="TenantDomain"></label>
            </td>
          </tr>
          <tr>
            <td>
              User Name
            </td>
            <td>
              <label id="TenantUserName"></label>
            </td>
          </tr>
          <tr>
            <td>
              Password
            </td>
            <td>
              <label id="TenantPassword"></label>
              <i title="This is one time password, will require to change on first logon"
                class="master-tooltip info-icon info-icon-red"></i>
            </td>
          </tr>
          <tr>
            <td>
              First Name
            </td>
            <td>
              <label id="TenantFirstName"></label>
            </td>
          </tr>
          <tr>
            <td>
              Last Name
            </td>
            <td>
              <label id="TenantLastName"></label>
            </td>
          </tr>
          <tr>
            <td>
              Email
            </td>
            <td>
              <label id="TenantEmail"></label>
            </td>
          </tr>
        </table>
      </div>
      <div style="padding: 20px 0 20px 0;">
        To get started using the features of this Microsoft Online Tenant login to either of the Microsoft Management
        Portals below.
        <br />
        <br />
        <div style="color: blue">
          <a href="https://portal.office.com" target="_blank">https://portal.office.com</a>
          <br>
          <a href="https://portal.office.com" target="_blank">https://portal.azure.com</a>
        </div>
      </div>
      <div style="padding: 0 0 20px 0;">
        As a Microsoft CSP reseller, it is your responsibility to provide your end user with a copy of the Microsoft
        Customer Agreement (MCA) terms and conditions.
        <br />
        <br />
        <a style="color: blue;" href="https://portal.dickerdata.com.au/resourcefiles/microsoft/MCA_AU_2019DEC.pdf"
          target="_blank">Microsoft Customer Agreement</a>
      </div>
    </div>
    <div class="reveal-buttons">
      <a class="button button-red button-small" style="color: white;" (click)="closeTenantPopup()">OK</a>
    </div>
  </div>
</div>
